module.exports = __webpack_public_path__ + "img/ekr.639ffb9a.png";